import React, { createContext, useContext, useState, ReactNode } from 'react';

interface EntityContextProps {
  selectedEntity: string;
  setSelectedEntity: (entityId: string) => void;
}

const EntityContext = createContext<EntityContextProps | undefined>(undefined);

export const useEntity = (): EntityContextProps => {
  const context = useContext(EntityContext);
  if (!context) {
    throw new Error('useEntity must be used within an EntityProvider');
  }
  return context;
};

export const EntityProvider = ({ children }: { children: ReactNode }) => {
  const [selectedEntity, setSelectedEntity] = useState<string>('');

  return (
    <EntityContext.Provider value={{ selectedEntity, setSelectedEntity }}>
      {children}
    </EntityContext.Provider>
  );
};